// redux/slices/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    theme: "light",
    colors:{},
    source:"tcs"
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        setClientSource:(state,action)=>{
            state.source=action.payload;
        },
        setColors:(state,action)=>{
            state.colors=action.payload;
        }
    },
});

export const { setTheme,setClientSource,setColors } = themeSlice.actions;
export default themeSlice.reducer;
